import { InputGroup } from '@chakra-ui/react';
export default InputGroup;